import RestrictMesh from "../resources/restrict-mesh";

class RestrictMoveAndRotate extends RestrictMesh {
    constructor() {
        super();
        this.retainColorForUserActionMoveObjects = false;
    }

    updateUserActionMoveObjectsRetainColor(retainColor) {
        this.retainColorForUserActionMoveObjects = !!retainColor;
    }
}

export default RestrictMoveAndRotate;